<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Audiences
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <AudienceList ref="audienceList" :account-id="accountId" />
      </div>
    </div>
  </div>
</template>

<script>
import AudienceList from './audiences/components/AudienceList.vue';

export default {
  components: { AudienceList },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
};
</script>
